// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__tg1cN","text":"Footer_text__Abbgj"};